import http, { httpV2 } from "../http.js";

const TransactionalService = {
  extensions: (objExtend) =>
    httpV2.post("transactionals/extensions", objExtend),
};

export default TransactionalService;
